export const mustBeInFuture = (inputDate: (Date | null) = new Date()): boolean => {
  const currentDate = new Date();
  return inputDate > currentDate;
}

export const mustBeInPast = (inputDate: (Date | null) = new Date()): boolean => {
  const currentDate = new Date();
  return inputDate < currentDate;
}
